module.exports = {
  hasProp: require('./hasProp'),
  hasProps: require('./hasProps'),
  hasPropPath: require('./hasPropPath'),
  isAlt: require('./isAlt'),
  isAlternative: require('./isAlternative'),
  isApplicative: require('./isApplicative'),
  isApply: require('./isApply'),
  isArray: require('./isArray'),
  isBifunctor: require('./isBifunctor'),
  isBichain: require('./isBichain'),
  isBoolean: require('./isBoolean'),
  isCategory: require('./isCategory'),
  isChain: require('./isChain'),
  isContravariant: require('./isContravariant'),
  isDate: require('./isDate'),
  isDefined: require('./isDefined'),
  isEmpty: require('./isEmpty'),
  isExtend: require('./isExtend'),
  isFalse: require('./isFalse'),
  isFalsy: require('./isFalsy'),
  isFoldable: require('./isFoldable'),
  isFunction: require('./isFunction'),
  isFunctor: require('./isFunctor'),
  isInteger: require('./isInteger'),
  isIterable: require('./isIterable'),
  isMap: require('./isMap'),
  isMonad: require('./isMonad'),
  isMonoid: require('./isMonoid'),
  isNil: require('./isNil'),
  isNumber: require('./isNumber'),
  isObject: require('./isObject'),
  isPlus: require('./isPlus'),
  isProfunctor: require('./isProfunctor'),
  isPromise: require('./isPromise'),
  isSame: require('./isSame'),
  isSameType: require('./isSameType'),
  isSemigroup: require('./isSemigroup'),
  isSemigroupoid: require('./isSemigroupoid'),
  isSetoid: require('./isSetoid'),
  isString: require('./isString'),
  isSymbol: require('./isSymbol'),
  isTraversable: require('./isTraversable'),
  isTrue: require('./isTrue'),
  isTruthy: require('./isTruthy'),
  pathEq: require('./pathEq'),
  pathSatisfies: require('./pathSatisfies'),
  propEq: require('./propEq'),
  propPathEq: require('./propPathEq'),
  propSatisfies: require('./propSatisfies'),
  propPathSatisfies: require('./propPathSatisfies')
}
